import { PublicKey } from '../../../common/certificates/models/valueObjects/PublicKey';
import { DateUtils } from '../../../common/utils/DateUtils';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { ReportCertificate } from '../models/ReportCertificate';

export class ReportCertificateMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any, reportId: number, reportVenafiLastUpdate: string | null): ReportCertificate {
    const publicKey = new PublicKey(this.gqlIdEncoder.decode(data.publicKey.id), data.publicKey.shortDescription, data.publicKey.hasPrivateKey);
    const expiryDate = data.notAfter ? DateUtils.toMoment(data.notAfter) : null;

    return new ReportCertificate(
      this.gqlIdEncoder.decode(data.id),
      data.subject,
      data.issuer,
      publicKey,
      data.fingerprint,
      expiryDate,
      data.signatureAlgorithm?.digest ?? null,
      reportId,
      data.venafiGuid,
      reportVenafiLastUpdate
    );
  }
}
